// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1278":"4-auth-msal","2698":"3-render-loginrenderer","3660":"2-polyfill-idle","7116":"4-feat-initialize-one-ds","7299":"4-feat-report-one-ds-event","7798":"4-feat-protobuf-request"}[chunkId] || chunkId) + ".js";
};